import React from 'react';
import _get from 'lodash/get';
import CheckboxButtonGrid from '@lib/components/CheckboxButtonGrid/CheckboxButtonGrid';
import { CheckboxButtonGroupOption } from '@lib/components/CheckboxButtonGrid/types';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import { ComponentProps, defaultProps } from '../types';

export default function CheckboxButtonGridPreview(props: ComponentProps) {
  const options = _get(
    props,
    FormTemplateFieldNames.Options,
    [],
  ) as CheckboxButtonGroupOption[];
  const limitToOneRespPerRow = _get(
    props,
    [
      FormTemplateFieldNames.Settings,
      FormTemplateFieldNames.LimitToOneRespPerRow,
    ],
    false,
  ) as boolean;
  const limitToOneRespPerColumn = _get(
    props,
    [
      FormTemplateFieldNames.Settings,
      FormTemplateFieldNames.LimitToOneRespPerColumn,
    ],
    false,
  ) as boolean;
  return (
    <CheckboxButtonGrid
      options={options}
      {...defaultProps}
      limitToOneRespPerRow={limitToOneRespPerRow}
      limitToOneRespPerColumn={limitToOneRespPerColumn}
    />
  );
}
